exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main.main .container-fluid[data-v-72bfda28]{position:relative}.loading-spiner-overlay[data-v-72bfda28]{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.7);z-index:1000}.loading-spiner-overlay .spinner.spinner--circle-2[data-v-72bfda28],.loading-spiner-overlay .spinner.spinner--rotate-square[data-v-72bfda28]{position:absolute;top:50%;left:50%;margin-top:-20px;margin-left:-20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72bfda28","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/LoadingSpinner.vue
// module id = xWaJ
// module chunks = 1